export const Paragraph = ({ children, className, size = '', style = {} }) => (
  <div className={`m-0 ${className}`} style={{ fontSize: size, ...style }}>
    {children}
  </div>
);
